// Soft, advisory check on a Poster-path Swish *message* (the mapping key): matching is
// prefix-based (see match_message), so a very short message collides easily with an unrelated
// payment to the same account. We only warn on length — judging whether a message is otherwise
// "distinctive enough" reliably isn't feasible, so we don't pretend to. Advisory only; the
// message is always accepted.

const MIN_LENGTH = 6

export type MessageStrength = { weak: boolean, reason: string | null }

export function messageStrength(message: string): MessageStrength {
    const m = message.trim()
    if (m === '' || m.length >= MIN_LENGTH) return { weak: false, reason: null }
    return { weak: true, reason: 'Kort meddelande — någon kan råka skriva samma sak för ett annat ändamål. Gör det längre och mer särskiljande.' }
}
